<div class="sw-cms-block-moorl-column-layout-nb-1-1">
    <slot name="slot-a"></slot>
    <slot name="slot-b"></slot>
</div>